import {gql} from '@apollo/client'

export const GET_ALL_CONTACTS_API = gql`
  query GetAllContactsAPI(
    $offset: Int
    $first: Int
    $name: String
    $status: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $createdAfter: Date
    $createdBefore: Date
    $birthMonth: String
    $ageFrom: String
    $ageTo: String
    $turning65In3Months: Boolean
    $gender: String
    $preferredLanguage: String
    $immigrationStatus: String
    $zipCode: String
    $isPolicyHolder: Boolean
    $withoutPolicy: Boolean
    $withoutLead: Boolean
    $myContacts: Boolean
    $isImportant: Boolean
    $user: String
    $assignedTo: String
    $signatureForm: String
    $hasSignedEntry: Boolean
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $isRecipient: Boolean
    $segment: String
    $organization: String
    $effectiveYear: String
  ) {
    allContacts(
      offset: $offset
      first: $first
      name: $name
      status: $status
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      birthMonth: $birthMonth
      ageFrom: $ageFrom
      ageTo: $ageTo
      turning65In3Months: $turning65In3Months
      gender: $gender
      preferredLanguage: $preferredLanguage
      immigrationStatus: $immigrationStatus
      zipCode: $zipCode
      isPolicyHolder: $isPolicyHolder
      withoutPolicy: $withoutPolicy
      withoutLead: $withoutLead
      myContacts: $myContacts
      isImportant: $isImportant
      user: $user
      assignedTo: $assignedTo
      signatureForm: $signatureForm
      hasSignedEntry: $hasSignedEntry
      effectiveDateAfter: $effectiveDateAfter
      effectiveDateBefore: $effectiveDateBefore
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      isRecipient: $isRecipient
      segment: $segment
      organization: $organization
      effectiveYear: $effectiveYear
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          zipCode
          created
          isImportant
          subscriptionStatus
          stateEU {
            id
            name
            code
          }
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
            rol
            relationship
            firstName
            lastName
            phone
            relationship
            policy {
              id
              policyName
              status
              stateDocs
              paymentStatus
              type
              created
              effectiveDate
              completedDate
              applicants
              members
              memberId
              hasAutoPolicy
              hasHomePolicy
              agentOfRecord
              zipCode
              stateEU {
                id
                code
              }
              user {
                id
                firstName
                lastName
                email
                cellphone
                avatar
              }
              holderMember {
                id
                firstName
                lastName
                phone
                rol
                relationship
              }
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              assignedTo {
                id
                firstName
                lastName
              }
            }
          }
          lead {
            id
          }
          members {
            edges {
              node {
                id
                rol
                relationship
                firstName
                lastName
                phone
                relationship
                policy {
                  id
                  policyName
                  status
                  stateDocs
                  paymentStatus
                  type
                  created
                  effectiveDate
                  completedDate
                  applicants
                  members
                  memberId
                  hasAutoPolicy
                  hasHomePolicy
                  agentOfRecord
                  zipCode
                  stateEU {
                    id
                    code
                  }
                  user {
                    id
                    firstName
                    lastName
                    email
                    cellphone
                    avatar
                  }
                  holderMember {
                    id
                    firstName
                    lastName
                    phone
                    rol
                    relationship
                  }
                  carrier {
                    id
                    name
                  }
                  typePolicy {
                    id
                    typePolicy
                  }
                  assignedTo {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          signatureEntries {
            edges {
              node {
                id
                signedOn
                requestedOn
                status
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_RECIPIENTS = gql`
  query GetAllRecipients(
    $offset: Int
    $first: Int
    $name: String
    $subscriptionStatus: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $segment: String
    $ids: String
  ) {
    allRecipients(
      offset: $offset
      first: $first
      name: $name
      subscriptionStatus: $subscriptionStatus
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      segment: $segment
      ids: $ids
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          created
          isImportant
          subscriptionStatus
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
          }
          signatureEntries {
            edges {
              node {
                id
                signedOn
                requestedOn
                status
              }
            }
          }
        }
      }
    }
    recipientStats {
      totalRecipients
      subscribedCount
      unsubscribedCount
    }
  }
`

export const GET_ONE_CONTACT_API = gql`
  query contactById($id: String!) {
    contactById(id: $id) {
      id
      fullName
      firstName
      lastName
      middleName
      secondLastName
      preferredLenguage
      dateBirth
      gender
      email
      phone
      address1
      address2
      city
      zipCode
      countyFips
      immigrationStatus
      annualIncome1
      annualIncome2
      annualIncome3
      isImportant
      stateEU {
        id
        name
      }
      memberPolicy {
        id
        rol
        firstName
        lastName
        phone
        relationship
        policy {
          id
          policyName
          status
          stateDocs
          paymentStatus
          type
          created
          effectiveDate
          completedDate
          applicants
          members
          memberId
          hasAutoPolicy
          hasHomePolicy
          agentOfRecord
          zipCode
          stateEU {
            id
            code
          }
          user {
            id
            firstName
            lastName
            email
            cellphone
            avatar
          }
          holderMember {
            id
            firstName
            lastName
            phone
            rol
            relationship
          }
          carrier {
            id
            name
          }
          typePolicy {
            id
            typePolicy
          }
          assignedTo {
            id
            firstName
            lastName
          }
        }
      }
      members {
        edges {
          node {
            id
            rol
            firstName
            lastName
            phone
            relationship
            policy {
              id
              policyName
              status
              stateDocs
              paymentStatus
              type
              created
              effectiveDate
              completedDate
              applicants
              members
              memberId
              hasAutoPolicy
              hasHomePolicy
              agentOfRecord
              zipCode
              stateEU {
                id
                code
              }
              user {
                id
                firstName
                lastName
                email
                cellphone
                avatar
              }
              holderMember {
                id
                firstName
                lastName
                phone
                rol
                relationship
              }
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              assignedTo {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
      user {
        id
        firstName
        lastName
      }
      created
      updated
    }
  }
`

export const GET_ALL_CONTACTS_PREVIEW = gql`
  query allContactsPreview(
    $name: String, 
  ) {
    allContactsPreview(    
      name: $name
    ) {
      edges {
        node {
          id
          fullName
          firstName
          middleName
          lastName
          secondLastName
          preferredLenguage
          phone
          dateBirth
          gender
          email
          address1
          address2
          city
          zipCode
          immigrationStatus
          stateEU {
            id
            name
          }
          memberPolicy {
            id
            rol
            policy {
              id
              status
              paymentStatus
              type
              policyName
              created
              completedDate
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              user {
                id
                firstName
                lastName
              }
              assignedTo {
                id
                firstName
                lastName
              }
              effectiveDate
            }
          }
          members {
            edges {
              node {
                id
                rol
                policy {
                  id
                  status
                  paymentStatus
                  type
                  policyName
                  created
                  completedDate
                  carrier {
                    id
                    name
                  }
                  typePolicy {
                    id
                    typePolicy
                  }
                  user {
                    id
                    firstName
                    lastName
                  }
                  assignedTo {
                    id
                    firstName
                    lastName
                  }
                  effectiveDate
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_CONTACT_COMMUNICATION_LOGS = gql`
  query allCommunications($originModule: String, $originId: String, $contactId: String) {
    allCommunications(first: 50, originModule: $originModule, originId: $originId, contact: $contactId) {
      edges {
        node {
          id
          channel
          direction
          status
          content
          metadata
          created
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`
